<template>
  <label class="app-checkbox">
    <input
      type="checkbox"
      @change="change"
      v-bind="$attrs"
      :checked="checked"
    />
    <span></span>
    <div v-if="label" v-html="label"></div>
  </label>
</template>

<script>
export default {
  props: [
    'value',
    'label'
  ],
  data() {
    return {
      checked: this.value
    }
  },
  updated() {
    this.checked = this.$props.value
  },
  methods: {
    change() {
      this.checked = !this.checked
      this.$emit('input', this.checked)
    }
  }
}
</script>
